import React, { useState, useEffect
} from 'react';
import { 
  Paper, 
  Container, 
  Typography, 
  Button, 
  Badge, 
  Card, 
  CardHeader, 
  IconButton,
  CardContent, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffectAsync } from '../reactHelper';
import ImageIcon from '@mui/icons-material/Image';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import MainToolbar from './MainToolbar';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import MainStyles from './utils/MainStyles';

import LoadingPage from '../LoadingPage';  // Adjust the path based on your directory structure

import {ReactComponent as NotificationIcon} from '../resources/images/track2you/Icons_Notification.svg';
import {ReactComponent as ActivityMapIcon} from '../resources/images/track2you/Icons_Activity_Map.svg';
import {ReactComponent as LocationIcon20} from '../resources/images/track2you/Icons_Location-06.svg';
import {ReactComponent as SettingsIcon} from '../resources/images/track2you/Icons_Settings.svg';


const MainPage = () => {
  const classes = MainStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = useSelector((state) => state.session.user);
  const devices = useSelector((state) => state.session.device);
  const notifications = useSelector((state) => state.session.notifications);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [anyDevice, setAnyDevice] = useState(false);
  

  useEffect(() => {
    if (!user || !notifications) {
      console.log("Device data not available yet. Fetching data...");
    } else {
      setLoading(false);
    }
    if(devices && devices.length>0){
      setAnyDevice(true);
      console.log("main page: ", devices);
    }else{
      setAnyDevice(false);
    }
  }, [user, notifications, devices]);

  const handleLinks = (event, value) => {
    switch (value) {
      case 'settings':
        navigate('/settings/settingsPage');
        break;
      case 'work':
        navigate('/work/workPage');
        break;
      case 'activities':
        navigate('/activities/activitiesPage');
        break;
      case 'map':
        navigate('/map/mainMap');
        break;
      case 'notifications':
        navigate('/settings/notifications');
        break;
      case 'logout':
        handleLogout;
        break;
      default:
        break;
    }
  };


  if (loading) {
    return <LoadingPage message="Fetching your data..." />;
  }

    return (
      <div className={classes.root}>
        <Paper square elevation={3} className={classes.header}>
          <MainToolbar />
        </Paper>
  
        <Container id="introContainer" className={classes.mainContainer}>
          <Typography className={classes.leftTitle} variant="h6" component="h6">
            Bem Vindo, <br />{user.name}!
          </Typography>
  
          <div className={classes.notificationsDiv}>
            <Button 
              className={classes.notificationsButton} 
              onClick={(event) => handleLinks(event, "notifications")}
              variant="text">
                {notifications!=null && ( 
                <Badge badgeContent={notifications.length} color="error" >
                  <NotificationIcon />
                </Badge>
                )}
                {!notifications && (
                 <NotificationIcon />
                )}
            </Button>
          </div>
        </Container>
  
        <Card id={"cardHomeWorkAreaHeader"} className={classes.homeWorkArea} >
          <CardHeader
            className={classes.homeWorkAreaHeader}
            avatar={
              <DirectionsCar className={classes.homeWorkAreaIcon} />
            }
            title={anyDevice? devices[0].uniqueId : 'Nenhum dispositivo'}
            subheaderTypographyProps={{ color: theme.palette.secondary.main, fontSize: '7pt', }} 
            subheader={anyDevice? devices[0].name : 'Falar com responsável'}
          />
          <CardContent>
            <Typography paragraph className={classes.cardContentTitle} variant="subtitle1" component="span">
              Área de Trabalho <br />
            </Typography>
            <Typography className={classes.homeWorkAreaText} variant="body2" component="span">
              Nesta secção consegue gerir
              o seu tempo de trabalho!
            </Typography>
            <Button className={classes.homeWorkAreaButton} onClick={(event) => handleLinks(event, "work")} >
              Avançar
            </Button>
          </CardContent>
        </Card>
  
        <Container id={"containerHomeCards1"} className={classes.homeCardsContainer} >
          <Card id={"cardHomeCardsHeader1"} className={classes.homeCards} >
            <CardHeader
              className={classes.homeCardsHeader}
              avatar={
                <ActivityMapIcon className={classes.homeCardsIcon} />
              }
              action={
                <IconButton aria-label="more" onClick={(event) => handleLinks(event, "activities")}>
                  <ArrowOutwardIcon/>
                </IconButton>
              }
            />
            <CardContent>
              <Typography paragraph className={classes.cardContentTitle} variant="h6" component="span">
                Atividades Pessoais <br />
              </Typography>
              <Typography className={classes.homeWorkAreaText} variant="body2" component="span">
                Descubra as suas
                atividades pessoais
              </Typography>
            </CardContent>
          </Card>
  
          <Card id={"cardHomeCardsHeader2"} className={classes.homeCards} >
            <CardHeader
              className={classes.homeCardsHeader}
              avatar={
                <LocationIcon20 className={classes.homeCardsIcon} />
              }
              action={
                <IconButton aria-label="more" onClick={(event) => handleLinks(event, "map")}>
                  <ArrowOutwardIcon/>
                </IconButton>
              }
            />
            <CardContent>
              <Typography paragraph className={classes.cardContentTitle} variant="h6" component="span">
                Minha Localização <br />
              </Typography>
              <Typography className={classes.homeWorkAreaText} variant="body2" component="span">
                Localização atual do utilizador
              </Typography>
            </CardContent>
          </Card>
        </Container>
  
        <Container id={"cardHomeCardsHeader2-1"} className={classes.homeCardsContainer} >
          <Card id={"cardHomeCardsHeader2-1"} className={classes.homeCards} >
            <CardHeader
              className={classes.homeCardsHeader}
              avatar={
                <SettingsIcon className={classes.homeCardsIcon} />
              }
              action={
                <IconButton aria-label="more" onClick={(event) => handleLinks(event, "settings")}>
                  <ArrowOutwardIcon/>
                </IconButton>
              }
            />
            <CardContent>
              <Typography paragraph className={classes.cardContentTitle} variant="h6" component="span">
                Definições <br /> Gerais <br />
              </Typography>
              <Typography className={classes.homeWorkAreaText} variant="body2" component="span">
                Dados gerais da app Track2You
              </Typography>
            </CardContent>
          </Card>
  
          <Card id={"cardHomeCardsHeader3-1"} className={classes.homeCards} >
            <CardHeader
              className={classes.homeCardsHeader}
              avatar={
                <NotificationIcon className={classes.homeCardsIcon} />
              }
              action={
                <IconButton aria-label="more" onClick={(event) => handleLinks(event, "notifications")}>
                  <ArrowOutwardIcon/>
                </IconButton>
              }
            />
            <CardContent>
              <Typography paragraph className={classes.cardContentTitle} variant="h6" component="span">
                Minhas Notifications<br />
              </Typography>
              <Typography className={classes.homeWorkAreaText} variant="body2" component="span">
                Local onde pode gerir as suas notificações
              </Typography>
            </CardContent>
          </Card>
        </Container>
  
      </div>
    );
  
};

export default MainPage;
